import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import Investment from './Investment';
import Listing from './Listing';
import Rentals from './Rentals';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TopSec() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Outlet />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value}
          textColor="#1E222B"
          TabIndicatorProps={{ style: { background: '#00BC67' } }}

          indicatorColor="secondary"
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={<p className=' capitalize font-[500] text-[16px]'>Investment</p>}
            {...a11yProps(0)} />
          <Tab label={<p className=' capitalize font-[500] text-[16px]'>Listing</p>} {...a11yProps(1)} />
          <Tab label={<p className=' capitalize font-[500] text-[16px]'>Rentals</p>} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Investment />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Listing />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Rentals />
      </TabPanel>

    </Box>
  );
}